
import { mapState } from 'vuex'

import Icon from '../../common/Icon';
import Logo from '../../_globals/layout/header/Logo.vue'

export default {
  name: 'SiteFooter',
  components: { 
    Icon,
    Logo,
  },
  props: {
    stores: {
      type: Array,
      default: () => []
    },
    menu: {
      type: Array,
      default: () => []
    },
    pages: {
      type: Array,
      default: () => []
    },
    social_links: {
      type: Array,
      default: () => []
    },
    logos: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapState([ 'appInfo' ]),
    appVersion() {
      const appVersion = process.env.APP_VERSION || ''

      return appVersion ? `| v${appVersion}` : ''
    },
    libraryVersion() {
      const libraryVersion = process.env.LIBRARY_VERSION || ''

      return libraryVersion && process.env.NODE_ENV === 'development' ? `| library v1 v${libraryVersion}` : ''
    },
  }
}
